// extracted by mini-css-extract-plugin
export default {"tabBar":"styles_tabBar__WEZOp","tab":"styles_tab__vzg6O","active":"styles_active__2NE81"};